import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';
import { BEACON_SUBTABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';
import ContentSummaryPage from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV2/ContentSummaryPage';
import ContentUtilizationPage from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV2/ContentUtilizationPage';
import ContentAccuracyV2Page from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV2/ContentAccuracyV2Page';
import ContentKeywordsPage from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV2/ContentKeywordsPage';
import ContentVoiceAndTonePage from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV2/ContentVoiceAndTonePage';
import ContentVariationsPage from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentVariationsPage';
import ContentSettingsPage from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV2/ContentSettingsPage';

const getContentV2PageLayout = ({ metricType }) => {
  if (metricType === BEACON_SUBTABS.CONTENT_SUMMARY) {
    return {
      CustomPageContainer: GenericPageContainer,
      enableComparison: false,
      widgets: [
        {
          name: BEACON_SUBTABS.CONTENT_SUMMARY,
          CustomComponent: ContentSummaryPage,
          view: {}
        }
      ],
      containerStyle: {},
      dataConfig: {}
    };
  }

  if (metricType === BEACON_SUBTABS.CONTENT_UTILIZATION) {
    return {
      CustomPageContainer: GenericPageContainer,
      enableComparison: false,
      widgets: [
        {
          name: BEACON_SUBTABS.CONTENT_UTILIZATION,
          CustomComponent: ContentUtilizationPage,
          view: {}
        }
      ],
      containerStyle: {},
      dataConfig: {}
    };
  }

  if (metricType === BEACON_SUBTABS.CONTENT_ACCURACY_V2) {
    return {
      CustomPageContainer: GenericPageContainer,
      enableComparison: false,
      widgets: [
        {
          name: BEACON_SUBTABS.CONTENT_ACCURACY_V2,
          CustomComponent: ContentAccuracyV2Page,
          view: {}
        }
      ],
      containerStyle: {},
      dataConfig: {}
    };
  }
  if (metricType === BEACON_SUBTABS.CONTENT_KEYWORDS) {
    return {
      CustomPageContainer: GenericPageContainer,
      enableComparison: false,
      widgets: [
        {
          name: BEACON_SUBTABS.CONTENT_KEYWORDS,
          CustomComponent: ContentKeywordsPage,
          view: {}
        }
      ],
      containerStyle: {},
      dataConfig: {}
    };
  }
  if (metricType === BEACON_SUBTABS.CONTENT_VOICE_AND_TONE) {
    return {
      CustomPageContainer: GenericPageContainer,
      enableComparison: false,
      widgets: [
        {
          name: BEACON_SUBTABS.CONTENT_VOICE_AND_TONE,
          CustomComponent: ContentVoiceAndTonePage,
          view: {}
        }
      ],
      containerStyle: {},
      dataConfig: {}
    };
  }
  if (metricType === BEACON_SUBTABS.CONTENT_VARIATIONS) {
    return {
      CustomPageContainer: GenericPageContainer,
      enableComparison: false,
      widgets: [
        {
          name: BEACON_SUBTABS.CONTENT_VARIATIONS,
          CustomComponent: ContentVariationsPage,
          view: {}
        }
      ],
      containerStyle: {},
      dataConfig: {}
    };
  }
  if (metricType === BEACON_SUBTABS.CONTENT_SETTINGS) {
    return {
      CustomPageContainer: GenericPageContainer,
      enableComparison: false,
      widgets: [
        {
          name: BEACON_SUBTABS.CONTENT_SETTINGS,
          CustomComponent: ContentSettingsPage,
          view: {}
        }
      ],
      containerStyle: {},
      dataConfig: {}
    };
  }

  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: BEACON_SUBTABS.CONTENT_SUMMARY,
        CustomComponent: ContentSummaryPage,
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
};

export default getContentV2PageLayout;
